import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="pt-40 pb-28">
      <SEO title="Terms of Service" description="DULORME LABS Terms of Service." path="/terms-of-service" />
      <div className="container-custom max-w-2xl">
        <FadeIn>
          <h1 className="font-display text-4xl font-bold text-white mb-10">Terms of Service</h1>
          <div className="space-y-8 text-sm text-zinc-400 leading-relaxed">
            <p>These Terms govern your use of the DULORME LABS™ website. By using this site, you agree to these Terms.</p>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Use of Site</h2>
              <p>Content on this site is provided for informational purposes and does not constitute a guarantee of services, pricing or results.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">No Guaranteed Results</h2>
              <p>Marketing, branding and growth outcomes vary by business, market and execution. DULORME LABS does not guarantee specific financial or performance results.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Intellectual Property</h2>
              <p>All content, branding and materials on this site are the property of DULORME LABS™ unless otherwise noted.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Limitation of Liability</h2>
              <p>DULORME LABS is not liable for indirect or consequential damages arising from use of this website.</p>
            </div>
            <p className="text-zinc-600">This is a placeholder document. Replace with terms reviewed by legal counsel before launch.</p>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}
